export default __webpack_public_path__ + "static/media/dashboard.83af1eef.jpg";